<div class="container-fluid webView">
    <!-- Header -->
    <div class="row" style="margin: 0px;">
        <div class="col-md-3 lblHeader newHeader" style="padding: 15px 5px 10px; font-size: 30px;">
            Profit & Loss
        </div>
        <div class="col-md-9" style="text-align: right; padding: 15px 20px;">
            <span (click)="Refresh()" class="btn btn-orange brdrRadius3"
                style="cursor: pointer;line-height: 23px; padding: 3px 9px" title="Refresh">
                <span>
                    <i aria-hidden="true" style="font-size: 13px;" class="fa fa-refresh"></i>
                </span>
            </span>

            <span style="margin-right: 10px; ">
                <span (click)="PrintProfitLoss()" title="Print" class="btn btn-orange brdrRadius3"
                    style="cursor: pointer;line-height: 22px; padding: 3px 9px; color:#fff; margin-left: 10px;">
                    <span>
                        <i aria-hidden="true" class="zmdi zmdi-print"
                            style="font-size: 14px; position: relative; top: 1px;"></i>
                    </span>
                </span>
            </span>

            <!-- <span  class="btn btn-brown" style="cursor: pointer;line-height: 22px; padding: 5px 11px;" title="Tag exportToExcel">
                <span>
                    <i aria-hidden="true"  style="font-size: 14px;" class="fa fa-file-excel-o"></i>
                </span>
            </span>  -->

            <div style="display: inline-block; text-align: right; padding: 0px;">
                <span class="darkBlueButton brdrRadius3" title="Back to account"
                    style="font-size: 13px; display: inline-block; padding: 5px 12px 6px;" (click)="backBtn()">
                    <i class="fa fa-chevron-left" style="margin-right: 3px;"></i> Back
                </span>
            </div>
            <!-- <input type="text" *ngIf="selectedFY == 'Other'" class="form-control" style="width: 22%; display: inline-block; padding: 1px 3px;"> -->
        </div>

    </div>


    <!-- Start Hide zeroes & Select date -->

    <div class="col-md-12 col-xs-12 col-sm-12 webView" style="display:inline-block;padding-left: 8px;">
        <div class="row" style="height: 40px !important;">
            <div style="display: inline-block; margin-right: 15px;margin-left: 15px;">
                <div class="checkbox font13">
                    <label (change)="clickHideZero();"
                        style="margin-bottom: 0px !important; margin-top: 5px; line-height: 30px; cursor: pointer;">
                        <input type="checkbox"  class="chkbox-darkblue" [(ngModel)]="hideZeroLevelLdgr"
                            style="margin-right: 5px;font-size: 13px; position: relative; top: 2px;">Hide zeroes</label>
                </div>
            </div>

            <!-- <div class="col-md-10 col-sm-10"> -->
            <div style="display: flex; align-items: center; column-gap: 8px;">
                <select class="form-control font13  formCtlFltr bgwhite" [(ngModel)]="selectedFY" (ngModelChange)="ddlchangeYear()"
                    style="display: inline-block; padding: 1px 3px; font-size: 13px; width: 125px;">
                    <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                    <option value="Other">Other</option>
                </select>

                <div style="display: flex; align-items: center; column-gap: 10px;" *ngIf="selectedFY == 'Other'">
                    <div style="outline: none !important; display: inline-block;">
                        <input matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [matDatepicker]="picker"
                            class="form-control  formCtlFltr bgwhite" tabindex="1" [(ngModel)]="fromDate"
                            style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                        <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                    </div>
                    <div style="font-size: 14px !important;">to</div>
                    <div style="outline: none !important; display: inline-block;">
                        <input matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2"
                            class="form-control  formCtlFltr bgwhite" tabindex="1" [(ngModel)]="toDate"
                            style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                        <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                    </div>
                    <div>
                        <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.edit" (click)="editPeriod()">
                            <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                            <span> Edit </span>
                        </span>
                        <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.save" (click)="changePeriod()">
                            <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                            <span> Fetch </span>
                        </span>
                    </div>
                </div>
            </div>

            <!-- </div>  -->
        </div>
    </div>
    <!-- End Hide zeroes & Select date -->

    <!-- Body -->
    <div class="row marginZero webView" style="padding-left: 8px;padding-right: 8px; margin-top: 20px;">
        <div class="col-md-12 mainCard table-bordered " style="padding: 0px !important; border-radius: 3px !important;">
            <!-- Left -->
            <div class="col-md-6 mainCardHeader"
                style="display: inline-block; border-right: 1px solid #ddd; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color: white; border-top-left-radius: 3px; padding: 10px;">
                    Expense
                </div>
                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss"
                    style="padding-top: 10px; font-size: 13px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;  color: rgb(232, 132, 33);">Opening Stock</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.OpeningStock |
                            cRDB}}</span>
                    </div>
                </div>
                <div class="col-md-12 font13" *ngFor="let Heads of BindRecordLeft">
                    <div style="margin-bottom: 10px;"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold; cursor: pointer;  color: rgb(232, 132, 33);"
                            (click)="expandView(Heads, 1)">{{Heads.HeadName}}</span>&nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal |
                            cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; color: rgb(31, 98, 142);"
                                        (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial; font-weight: normal;">₹</span>{{SubHead.CloBal |
                                        cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; font-style: italic; color:#4caf50;"
                                        (click)="expandView(SubLedger, 0)">{{SubLedger.LedgerName}}</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial; font-weight: normal;">₹</span>{{SubLedger.CloBal
                                        | cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-12" style="font-size: 13px;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                        <span style="font-weight: bold; color: rgb(232, 132, 33);">Current Profit</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{ProfitOrLoss |
                            cRDB}}</span>
                    </div>
                </div>
            </div>
            <!-- Right -->
            <div class="col-md-6 mainCardHeader"
                style="border-left: 1px solid #ddd; display: inline-block; padding: 0px; vertical-align: top;">
                <div class="col-md-12"
                    style="text-align: center; border-bottom: 1px solid #ddd; background-color: white; border-top-right-radius: 3px; padding: 10px;">
                    Income
                </div>
                <div class="col-md-12" *ngFor="let Stock of AccurateProfitOrLoss"
                    style="padding-top: 10px; font-size: 13px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold; color: rgb(232, 132, 33);">Closing Stock</span> &nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.ClosingStock |
                            cRDB}}</span>
                    </div>
                </div>
                <div class="col-md-12" *ngFor="let Heads of BindRecordRight" style="font-size: 12px;">
                    <div style="margin-bottom: 10px;"
                        *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                        <span style="font-weight: bold; cursor: pointer; color: rgb(232, 132, 33);"
                            (click)="expandView(Heads, 1)">{{Heads.HeadName}}</span>&nbsp;
                        <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal |
                            cRDB}}</span>
                        <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px;">
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubHead of Heads.SubHead">
                                <div *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; color: rgb(31, 98, 142);"
                                        (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</span>
                                    <span class="pull-right"><span style="font-family: Arial;">₹</span>{{SubHead.CloBal
                                        | cRDB}}</span>
                                </div>
                            </div>
                            <div class="col-md-12" style="padding-left: 20px; padding-right: 40px;"
                                *ngFor="let SubLedger of Heads.Ledger">
                                <div *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                    <span style="cursor: pointer; font-style: italic; color:#4caf50;"
                                        (click)="expandView(SubLedger, 0)">{{SubLedger.LedgerName}}</span>
                                    <span class="pull-right"><span
                                            style="font-family: Arial;">₹</span>{{SubLedger.CloBal |
                                        cRDB}}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-md-12" style="font-size: 13px;">
                    <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                        <span style="font-weight: bold; color: rgb(232, 132, 33);">Current Loss</span> &nbsp;
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB }}</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-md-12 table-bordered"
            style="padding-left: 0px; padding-right: 0px; border-top: none; margin-bottom: 30px; border-bottom-left-radius: 3px; border-bottom-right-radius: 3px; font-size: 13px;
                        background-color: white; box-shadow: 0 .5rem 1rem rgba(0,0,0,.15)!important;"
            id="MainDiv1">
            <div class="col-md-6"
                style="border-right: 1px solid #ddd; padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-right: 15px; padding-top: 10px; padding-bottom: 3px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{GrandExpense | cRDB}}</span>
                    </div>
                </div>
            </div>

            <div class="col-md-6" style="padding-left: 0px; padding-right: 0px; display: inline-block;">
                <div class="col-md-12" style="padding-right: 15px; padding-top: 10px;">
                    <div style="margin-bottom: 10px;">
                        <span style="font-weight: bold;">Total</span>
                        <span class="pull-right" style="font-weight: bold;"><span
                                style="font-family: Arial;">₹</span>{{GrandIncome | cRDB}}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container-fluid mobView">
    <!-- Header -->
    <div class="row">
        <div class="col-md-6" style="padding: 20px; font-size: 30px; padding-bottom: 0px;">
            <!-- <span class="mobViewBtnBack" style="font-size: 22px; margin-right: 10px;" (click)="backBtn()"><i
                    class="fa fa-chevron-left"></i>
            </span> -->
            <h4 style="display: inline-block;" class="newHeader">Profit & Loss</h4>
            <span class="btn darkBlueButton" 
                style="margin-left: 7px !important; float: right; position: relative; padding: 2px 9px; top: 8px; line-height: 15px;" 
                (click)="backBtn()">
                    <i class="zmdi zmdi-arrow-left" style="margin-right: 5px;"></i>Back
            </span>
        </div>
        <div class="col-md-6" style="text-align: left; padding: 20px;">
            <div style="display: inline-block; margin-right: 15px;">
                <div class="checkbox">
                    <label class="font13" style="margin-bottom: 0px !important; line-height: 30px; cursor: pointer;">
                        <input type="checkbox" [(ngModel)]="hideZeroLevelLdgr"
                            style="margin-right: 5px;height: 13px;vertical-align: text-top;">Hide
                        zeroes</label>
                </div>
            </div>
            <!-- <span class="calender mobView" style="color: #e88421;padding: 1px 0px 5px 7px;display:inline-block"> <i
                    class="fa fa-calendar" aria-hidden="true"></i></span>

            <div style="display: inline-block; " [style.width]="selectedFY == 'Other' ? '100px' : '111px'">
              
                <select class="form-control font13" *ngIf="selectedFY != 'Other'" [(ngModel)]="selectedFY"
                    (ngModelChange)="ddlchangeYear()" style="display: inline-block; padding: 1px 3px;">
                    <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                    <option value="Other">Other</option>
                </select>
                <div style="outline: none !important; display: inline-block; width: 47%;" *ngIf="selectedFY == 'Other'">
                    <input matInput readonly (focus)="picker.open()" [matDatepicker]="picker"
                        class="form-control font13" tabindex="1" [(ngModel)]="fromDate"
                        (ngModelChange)="fn_ChangeDate()"
                        style="display: inline-block; width: 55%; outline: none !important; cursor: pointer; background: #FFF;">
                    <mat-datepicker-toggle matSuffix [for]="picker"
                        style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
                    <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
                </div>
                <div style="display: inline-block; margin-right: 15px; margin-left: -15px;">to</div>
                <div style="outline: none !important; display: inline-block; width: 47%;">
                    <input matInput readonly (focus)="picker2.open()" [matDatepicker]="picker2"
                        class="form-control font13" tabindex="1" [(ngModel)]="toDate" (ngModelChange)="fn_ChangeDate()"
                        style="display: inline-block; width: 55%; outline: none !important; cursor: pointer; background: #FFF;">
                    <mat-datepicker-toggle matSuffix [for]="picker2"
                        style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
                    <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
                </div>
            </div> -->

            <span class="calender mobView" style="color: #e88421;padding: 1px 0px 5px 7px;display: inline-block;"> <i
                    class="fa fa-calendar" aria-hidden="true"></i></span>

            <select class="form-control formCtlFltr font13" placeholder="Other" [(ngModel)]="selectedFY"
                (ngModelChange)="ddlchangeYear()" style="display: inline-block; margin-left: 10px; width: 115px; ">
                <option value="0" selected disabled hidden>Other</option>
                <option *ngFor="let f of financialYears" [ngValue]="f.FY">FY {{f.FY}}</option>
                <option value="Other">Other</option>
            </select>
            <!-- 
        <div style="display: inline-block;; margin-left: 20px; " *ngIf="selectedFY == 'Other'">
            <input matInput readonly (focus)="picker.open()" [(ngModel)]="toDate" [matDatepicker]="picker"
                class="form-control" (ngModelChange)="fn_ChangeDate()"
                style="display: inline-block; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
            <mat-datepicker-toggle matSuffix [for]="picker"
                style="display: inline-block; outline: none !important;"></mat-datepicker-toggle>
            <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
        </div> -->

        <div style="display: flex; flex-wrap: wrap; align-items: center; column-gap: 10px; margin-top: 5px;" *ngIf="selectedFY == 'Other'">
            <div style="outline: none !important; display: inline-block; margin-top: 5px;">
                <input matInput readonly disabled="{{disable.fromInput}}" (focus)="picker.open()" [matDatepicker]="picker"
                    class="form-control  formCtlFltr bgwhite" tabindex="1" [(ngModel)]="fromDate"
                    style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                <mat-datepicker #picker style="outline: none !important;"></mat-datepicker>
            </div>
            <div style="margin-top: 5px; font-size: 14px !important;">to</div>
            <div style="outline: none !important; display: inline-block; margin-top: 5px;">
                <input matInput readonly disabled="{{disable.toInput}}" (focus)="picker2.open()" [matDatepicker]="picker2"
                    class="form-control  formCtlFltr bgwhite" tabindex="1" [(ngModel)]="toDate"
                    style="display: inline-block; width: 90px; outline: none !important; cursor: pointer; background: #FFF;font-size: 13px;">
                <mat-datepicker #picker2 style="outline: none !important;"></mat-datepicker>
            </div>
            <div style="margin-top: 5px;">
                <span *ngIf="show.edit" class="orangeButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.edit" (click)="editPeriod()">
                    <i class="zmdi zmdi-edit" style="margin-right: 5px;"></i>
                    <span> Edit </span>
                </span>
                <span *ngIf="show.save" class="darkBlueButton" style="width: auto; height: 30px; font-size: 13px !important;" [(ngModel)]="show.save" (click)="changePeriod()">
                    <i class="zmdi zmdi-arrow-right" style="margin-right: 5px;"></i>
                    <span> Fetch </span>
                </span>
            </div>
        </div>

        </div>
    </div>

    <!-- Body -->
    <div class="row marginZero">
        <div class="col-md-12" style="padding: 0px !important;">
            <!-- Left -->
            <div class="col-md-6 mainCardHeader shadow"
                style="display: inline-block; border: 1px solid #ddd; border-radius: 3px; padding: 0px; vertical-align: top;">
                <div class="col-md-12" (click)="isShowExpense = !isShowExpense"
                    style="text-align: center; background-color: #f5f5f5; border-top-left-radius: 10px; border-top-right-radius: 10px; padding: 10px; {{isShowExpense ? ' border-bottom: 1px solid #ddd;' : ''}}">
                    Expense
                </div>

                <div *ngIf="isShowExpense">
                    <div class="col-md-12 font13" *ngFor="let Stock of AccurateProfitOrLoss" style="padding-top: 10px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Opening Stock</span> &nbsp;
                            <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.OpeningStock |
                                cRDB}}</span>
                        </div>
                    </div>
                    <div class="col-md-12 font13" *ngFor="let Heads of BindRecordLeft">
                        <div style="margin-bottom: 10px;"
                            *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                            <span style="font-weight: bold; cursor: pointer;"
                                (click)="expandView(Heads, 1)">{{Heads.HeadName}}</span>&nbsp;
                            <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal |
                                cRDB}}</span>
                            <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px; padding-left: 0px;">
                                <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 20px;"
                                    *ngFor="let SubHead of Heads.SubHead">
                                    <div
                                        *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span style="cursor: pointer;" (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial; font-weight: normal;">₹</span>{{SubHead.CloBal
                                            | cRDB}}</span>
                                    </div>
                                </div>
                                <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 20px;"
                                    *ngFor="let SubLedger of Heads.Ledger">
                                    <div
                                        *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span style="cursor: pointer; font-style: italic;"
                                            (click)="expandView(SubLedger, 0)">{{SubLedger.LedgerName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial; font-weight: normal;">₹</span>{{SubLedger.CloBal
                                            | cRDB}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="col-md-12 font13">
                        <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss > 0">
                            <span style="font-weight: bold;">Current Profit</span> &nbsp;
                            <span class="pull-right"><span style="font-family: Arial;">₹</span>{{ProfitOrLoss |
                                cRDB}}</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 font13"
                    style="padding-left: 0px; padding-right: 0px; display: inline-block; border-top: 1px solid #ddd;">
                    <div class="col-md-12" style="padding-right: 15px; padding-top: 3px; padding-bottom: 3px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Total</span>
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{GrandExpense | cRDB}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Right -->
            <div class="col-md-6 mainCardHeader shadow"
                style="display: inline-block; border: 1px solid #ddd; border-radius: 3px; padding: 0px; vertical-align: top; margin-top: 15px; margin-bottom: 20px;">
                <div class="col-md-12" (click)="isShowIncome = !isShowIncome"
                    style="text-align: center; background-color: #f5f5f5; border-top-right-radius: 10px; border-top-left-radius: 10px; padding: 10px; {{isShowIncome ? ' border-bottom: 1px solid #ddd;' : ''}}">
                    Income
                </div>

                <div *ngIf="isShowIncome">
                    <div class="col-md-12 font13" *ngFor="let Stock of AccurateProfitOrLoss" style="padding-top: 10px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Closing Stock</span> &nbsp;
                            <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Stock.ClosingStock |
                                cRDB}}</span>
                        </div>
                    </div>
                    <div class="col-md-12 font13" *ngFor="let Heads of BindRecordRight">
                        <div style="margin-bottom: 10px;"
                            *ngIf="(Heads.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                            <span style="font-weight: bold; cursor: pointer;" (click)="expandView(Heads, 1)">{{Heads.HeadName}}</span>&nbsp;
                            <span class="pull-right"><span style="font-family: Arial;">₹</span>{{Heads.CloBal |
                                cRDB}}</span>
                            <div class="col-md-12" style="padding-right: 0px; margin-bottom: 10px; padding-left: 0px;">
                                <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 20px;"
                                    *ngFor="let SubHead of Heads.SubHead">
                                    <div
                                        *ngIf="(SubHead.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span style="cursor: pointer;" (click)="expandView(SubHead, 1)">{{SubHead.HeadName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubHead.CloBal | cRDB}}</span>
                                    </div>
                                </div>
                                <div class="col-md-12 font12" style="padding-left: 20px; padding-right: 20px;"
                                    *ngFor="let SubLedger of Heads.Ledger">
                                    <div
                                        *ngIf="(SubLedger.CloBal != '0.00' && hideZeroLevelLdgr) || (!hideZeroLevelLdgr)">
                                        <span (click)="expandView(SubLedger, 0)"
                                            style="cursor: pointer; font-style: italic;">{{SubLedger.LedgerName}}</span>
                                        <span class="pull-right"><span
                                                style="font-family: Arial;">₹</span>{{SubLedger.CloBal | cRDB}}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 font13">
                        <div style="margin-bottom: 10px;" *ngIf="ProfitOrLoss < 0">
                            <span style="font-weight: bold;">Current Loss</span> &nbsp;
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{ProfitOrLoss | cRDB }}</span>
                        </div>
                    </div>
                </div>

                <div class="col-md-12 font13"
                    style="padding-left: 0px; padding-right: 0px; display: inline-block; border-top: 1px solid #ddd;">
                    <div class="col-md-12" style="padding-right: 15px; padding-top: 3px;">
                        <div style="margin-bottom: 10px;">
                            <span style="font-weight: bold;">Total</span>
                            <span class="pull-right" style="font-weight: bold;"><span
                                    style="font-family: Arial;">₹</span>{{GrandIncome | cRDB}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<ngx-spinner color="rgb(232, 132, 33)" size="default" type="ball-clip-rotate">

</ngx-spinner>